import { useRef, useMemo } from 'react';
import { IconButton } from '@ui/kit';
import { CrossIcon, CompactDotsIcon } from '@ui/kit/icons';
import { useToggleState } from '@utils/react';
import { actionsContext } from '../context.js';
import { SolidDropdownContent, SolidDropdown } from './dropdown.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function SolidContextmenu(props) {
  const internalRef = useRef(null);
  const triggerRef = props.togglerRef ?? internalRef;
  const [internalActive, internalActions] = useToggleState(props.active);
  const active = props.active ?? internalActive;
  const onToggle = props.onToggle ?? internalActions.toggle;
  const onClose = props.onClose ?? internalActions.disable;
  const actions = useMemo(() => ({
    onClose
  }), [onClose]);
  if (props.content === "list") {
    return /*#__PURE__*/jsx(actionsContext.Provider, {
      value: actions,
      children: /*#__PURE__*/jsx(SolidDropdownContent, {
        ...props
      })
    });
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(IconButton, {
      ref: triggerRef,
      disabled: typeof props.enabled === "boolean" && !props.enabled,
      className: props.togglerClassName,
      active: active,
      icon: /*#__PURE__*/jsx(CompactDotsIcon, {
        width: 15
      }),
      activeIcon: /*#__PURE__*/jsx(CrossIcon, {
        height: 16
      }),
      label: props.label,
      onClick: onToggle
    }), /*#__PURE__*/jsx(actionsContext.Provider, {
      value: actions,
      children: /*#__PURE__*/jsx(SolidDropdown, {
        ...props,
        active: active,
        triggerRef: triggerRef,
        onClose: onClose
      })
    })]
  });
}

export { SolidContextmenu };
//# sourceMappingURL=trigger.js.map
